import React, { Fragment } from 'react'
import { useSelector } from "react-redux";
import { createTrafficLightIcon } from './TrafficLightLocationIcon';
import TrafficLightMarkerPopup from './TrafficLightMarkerPopup';
import { selectIntersections } from "../../trafficInfra/trafficInfraSlice";
import { AutoOpenMarker } from "./AutoOpenMarker";

import L from 'leaflet';
import { selectIsDrivingMode, selectCurrentBearing, selectIsHeadingUp } from "../mapSlice";

const TrafficLightMarkers = ({ routeCoordinates, routeProximity = 20 }) => {
    const intersections = useSelector(selectIntersections);
    const isDrivingMode = useSelector(selectIsDrivingMode);
    let features = intersections?.features;

    if (isDrivingMode && routeCoordinates && features) {
        features = features.filter(feature => {
            const { geometry } = feature;
            if (!geometry) return false;
            const { coordinates } = geometry;
            // coordinates are [lng, lat] in GeoJSON, but Leaflet uses [lat, lng]
            const markerLatLng = L.latLng(coordinates[0][1], coordinates[0][0]);

            // Check if marker is close to any point on the route
            // Use configurable threshold
            return routeCoordinates.some(coord => markerLatLng.distanceTo(coord) < routeProximity);
        });
    }

    const currentBearing = useSelector(selectCurrentBearing);
    const isHeadingUp = useSelector(selectIsHeadingUp);

    // Calculate rotation: 
    // If Heading Up AND Driving Mode, the map is rotated -bearing. 
    // To keep the marker upright, we rotate it +bearing.
    const markerRotation = (isDrivingMode && isHeadingUp) ? currentBearing : 0;

    const renderMarker = (feature, index) => {
        const { geometry, properties } = feature;

        if (!geometry) {
            return null;
        }

        const { coordinates } = geometry;
        const { paikka, liva_nro } = properties;
        const position = { lat: coordinates[0][1], lng: coordinates[0][0] };

        // Create icon for this render. 
        // Note: Leaflet markers handle updating the icon when the object changes efficiently enough for this scale.
        const icon = createTrafficLightIcon(markerRotation);

        return (
            <AutoOpenMarker
                key={`${liva_nro}-${index}`}
                position={position}
                title={paikka}
                icon={icon}
                autoOpenId={liva_nro}
            >
                <TrafficLightMarkerPopup data={feature} />
            </AutoOpenMarker>
        );
    };

    const markers = features?.map(renderMarker);

    return <>{markers}</>;
};

export default TrafficLightMarkers;
